
<template>
<div class="icon-button" 
:class="classes"
:style="styles">
    <button 
    :disabled="disabled"
    class="icon-button__button"
    @click="onClick"
    :aria-label="label"
    >
        <img class="icon-button__icon" aria-hidden="true" :src="icon" alt=""/>
    </button>
    <label v-if="label" class="icon-button__label">{{label}}</label>
</div>
</template>

<script>
export default {
    name: "IconButton",
    props: {
        icon: String,
        variant: String,
        iconSize: {
            type: String,
            default: "25px"
        },
        label: String,
        disabled: Boolean,
        colour: {
            type: String,
            default: "ghost"
        }
    },
    methods: {
        onClick(e) {
            this.$emit("onClick", e)
        },
    },
    computed: {
        classes() {
            return [
                `icon-button--${this.colour}`,
                `icon-button--${this.variant}`
            ]
        },
        styles() {
            return {
                '--icon-size': this.iconSize
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.icon-button {
    display: flex;
    align-items: center;
    flex-direction: column;

    &__button {
        width: 60px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        border: none;
        background: none;
        transition: 0.2s;
        cursor: pointer;
    }

    &__icon {
        width: var(--icon-size);
        height: var(--icon-size);
    }

    &__label {
        font-size: 0.75rem; /** 12px */
        font-weight: bold;
        color: $grey-2;
        margin-top: 10px;
    }

    &--small {
        .icon-button {
            &__button {
                width: 50px;
                height: 50px;
            }

            &__icon {
                width: 20px;
                height: 20px;
            }
        }
    }

    &--ghost {
        .icon-button__button {
            border: 2px solid $grey-3;
            &:hover {
                background-color: $grey-6;
            }
        }
    }

    &--green {
        .icon-button__button {
            background-color: #56ae27;
            &:hover {
                background-color: #6cc73c;
            } 
        }
    }

    &--grey {
        .icon-button__button {
            background-color: #707070;
            &:hover {
                background-color: #8d8a8a;
            } 
        }
    }

    &--red {
        .icon-button__button {
            background-color: $red;
            &:hover {
                background-color: #ff535f
            } 
        }
    }
}
</style>